<template>
  <div style="padding: 5px">
    <el-table
      v-loading="loading"
      :data="msgList"
      style="width: 100%">
      <el-table-column
        type="expand">
        <template slot-scope="props">
          <div class="msgPadding">
            <span>作品类型：</span>{{props.row.informationData.label}}
          </div>
          <div class="msgPadding">
            <span>内容：</span>{{props.row.content}}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="businessId"
        label="作品编号">
      </el-table-column>
      <el-table-column
        prop="sendTime"
        label="接收时间">
      </el-table-column>
      <el-table-column
        label="状态">
        <template slot-scope="scope">
          <el-tag type="danger" v-if="scope.row.status=='0'">未读</el-tag>
          <el-tag v-else type="success">已读</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="editStatus(scope.row)">标记已读</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="padding-top: 10px"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageSizes"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
import {listMessage, updateMessage, workMsgList} from '../../api/system/message'
import {getData, listData} from '../../api/work/workdata'
import {listWorksCategoryConf} from '../../api/work/worksCategoryConf'

export default {
  name: 'myWorkMessage',
  data () {
    return {
      loading: true,
      msgList: [],
      currentPage: 1,
      pageSizes: 10,
      total: 0,
      workTypeList: []
    }
  },
  created () {
    this.getMsgList()
  },
  methods: {
    editStatus (row) {
      if (row.status == 1) { return }
      updateMessage(this.systemURL, {
        id: row.id,
        status: 1
      }).then(res => {
        this.getMsgList()
      })
    },
    handleSizeChange (val) {
      this.pageSizes = val
      this.getMsgList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getMsgList()
    },
    getMsgList () {
      this.loading = true
      workMsgList(this.systemURL, {
        recipientId: this.$store.state.user.userId,
        pageNum: this.currentPage,
        pageSize: this.pageSizes,
        result: 1,
        type: 4,
        siteId: this.siteId,
        log:"1"
      }).then(res => {
        this.total = res.total
        this.msgList = []
        res.rows.forEach(item => {
          this.msgList.push({...item.message, informationData: item.informationData})
        })
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
  .msgPadding{
    padding-top: 10px;
  }
  .msgPadding span{
    font-weight: bold;
    color: gray;
  }
</style>



// WEBPACK FOOTER //
// src/views/my/myWorkMessage.vue